module.exports = __webpack_public_path__ + "assets/img/suzhou.0c40e389.png";